import * as React from "react";

function SvgBlockUser(props) {
  return (
    <span className="iiht-svg">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -9 34 34" width={24.503} height={27.582} {...props}>
        <g data-name="Group 10869">
          <path
            d="M8.933 0a7.319 7.319 0 00-5.216 2.162 7.324 7.324 0 00-2.162 5.215 7.319 7.319 0 002.162 5.216 7.309 7.309 0 002.848 1.772 8.585 8.585 0 00-1.108.384 8.893 8.893 0 00-2.84 1.917A8.893 8.893 0 00.7 19.506a8.891 8.891 0 00-.7 3.479.965.965 0 00.964.964.965.965 0 00.965-.964 6.959 6.959 0 012.052-4.955 6.959 6.959 0 014.955-2.052 6.962 6.962 0 014.955 2.052 6.961 6.961 0 012.052 4.955.965.965 0 00.964.964.965.965 0 00.964-.964 9 9 0 00-.707-3.479 8.893 8.893 0 00-1.915-2.839 8.9 8.9 0 00-2.839-1.918 9.2 9.2 0 00-1.11-.384 7.313 7.313 0 002.847-1.773 7.328 7.328 0 002.162-5.216 7.315 7.315 0 00-2.162-5.215A7.324 7.324 0 008.933 0zm0 12.825a5.455 5.455 0 01-5.449-5.449 5.454 5.454 0 015.447-5.447 5.454 5.454 0 015.448 5.448 5.454 5.454 0 01-5.448 5.448z"
            fill="#3c4252"
          />
          <g data-name="Group 4556" stroke="#3c4252" strokeWidth={1.7}>
            <g data-name="Ellipse 675" transform="translate(11.503 14.582)" fill="#fff">
              <circle cx={6.5} cy={6.5} r={6.5} stroke="none" />
              <circle cx={6.5} cy={6.5} r={5.65} fill="none" />
            </g>
            <path data-name="Line 436" fill="none" d="M21.323 16.148l-7.08 10.226" />
          </g>
        </g>
      </svg>
    </span>
  );
}

export default SvgBlockUser;
